import React from "react";
import {
  Parah,
  PointsIcon,
  PointsWrapper,
  ThirdTitle,
} from "../ContentsStyles";

const PP_5 = () => {
  return (
    <>
      <Parah>
        You have rights and choices when it comes to your information. Some of
        these rights apply generally, while others will only apply in certain
        circumstances. Depending on the scenario, these rights may be subject to
        some limitations.
      </Parah>
      <ThirdTitle>Access your information</ThirdTitle>
      <PointsWrapper>
        You can ask us, free of charge, to confirm what information we process
        about you, to provide certain information about the processing, and for
        a copy of your information. In-app controls enable you to
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        Access your information that is available to other users when you
        navigate to settings for your account.
      </PointsWrapper>
      <ThirdTitle>Delete your information</ThirdTitle>
      <PointsWrapper>
        You can delete or ask us to delete some or all of your information.
        In-app controls enable you to:
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        delete the content posted on your profile, such as your User Content and
        your Profile Information.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        delete your full account.
      </PointsWrapper>
      <PointsWrapper>
        <PointsIcon />
        request the deletion of a particular piece of content using the in-app
        reporting feature.
      </PointsWrapper>
      <ThirdTitle>Rectify your information</ThirdTitle>
      <PointsWrapper>
        You can change or ask us to change or correct your information where
        that information is not accurate. You can change or correct much of your
        information through the in-app controls and settings.
      </PointsWrapper>
      <ThirdTitle>Port your information</ThirdTitle>
      <PointsWrapper>
        You have the right to data portability in circumstances where we rely on
        contractual necessity or consent as our legal basis. This means that you
        have the right to receive your information in a structured, commonly
        used, and machine-readable format and to share it with a third party.
      </PointsWrapper>
      <ThirdTitle>Object to the processing of your information</ThirdTitle>
      <PointsWrapper>
        You also have the right to object to the processing of your information
        in certain circumstances. This right applies when we are performing a
        task in the public interest or pursuing our legitimate interests or
        those of a third party. In submitting an objection request, please
        provide all relevant information, including the processing activity you
        are objecting to, why you want to object and how the processing activity
        affects you, and any additional information that you think will help us
        review your request. We will stop the particular processing if we don't
        have compelling legitimate grounds to continue that processing or don’t
        need it for legal claims.
      </PointsWrapper>
      <ThirdTitle>Restrict the processing of your information</ThirdTitle>
      <PointsWrapper>
        You have the right to request the restriction of the processing of your
        information where (a) you are challenging the accuracy of the
        information, (b) the information has been unlawfully processed, but you
        are opposing the deletion of that information, (c) where you need the
        information to be retained for the pursuit or defence of a legal claim,
        or (d) you have objected to processing and you are awaiting the outcome
        of that objection request.
      </PointsWrapper>
      <PointsWrapper>
        To exercise any of the above rights, please contact us. Before we can
        respond to a request to exercise one or more of the rights listed above,
        you may be required to verify your identity or your account details or
        provide additional information so that we can understand your request.
      </PointsWrapper>
      <PointsWrapper>
        We encourage you to “Contact us” if you are not satisfied with how we
        have responded to any of your rights requests. You also have the right
        to lodge a complaint with your local supervisory authority.
      </PointsWrapper>
    </>
  );
};

export default PP_5;
